import api from '@/services/api'

const state = {
  current: {  },
}

const getters = {}

const actions = {
  importRules ({ commit }, id) {
    return new Promise( (resolve) => {
      api().get('/blackbox/upload/' + id).then( (response) => {
        resolve(response.data)
      });
    })
  },
  delete({}, id) {
    return new Promise( (resolve) => {
      api().delete(`/blackbox/rules/${id}`).then( (response) => {
        resolve(response.data)
      })
    })
  },
  update({}, rule) {
    return new Promise( (resolve) => {
      api().post('/blackbox/rules', rule).then( (response) => {
        resolve(response.data)
      })
    })
  },
  store({}, rule) {
    return new Promise( (resolve) => {
      api().put('/blackbox/rules', rule).then( (response) => {
        resolve(response.data)
      })
    })
  },
  list({}) {
    return new Promise( (resolve) => {
      api().get('/blackbox/rules').then( (response) => {
        resolve(response.data)
      })
    })
  },
}

const mutations = {
  current (state, current) {
    state.current = current
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/blackbox.js